import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-loader app-loader--contextual"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dialogStepEntrancePlantComponent), {
      ref: _ctx.dialogStepEntrancePlantComponent,
      plant: _ctx.entrancePlant,
      "plant-id": _ctx.plantId,
      isEdit: _ctx.isEdit,
      onIsLoading: _ctx.handleStepLoading,
      onOnBack: _ctx.handleBack,
      onOnNext: _ctx.handleNext,
      onPlantEdited: _ctx.handleEditedPlant
    }, null, 8, ["plant", "plant-id", "isEdit", "onIsLoading", "onOnBack", "onOnNext", "onPlantEdited"])),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_ProgressSpinner)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}